// extracted by mini-css-extract-plugin
export default {"row":"FormulaModeColumn_row__gZokf","item":"FormulaModeColumn_item__2eN4z","item2":"FormulaModeColumn_item2__DCt3c","mobile":"FormulaModeColumn_mobile__9DG6j"};